<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div class="title">编辑</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body">
        <el-form :model="editForm" :rules="rules" ref="editForm">
          <el-row>

            <el-col :span="12" class="item">
              <el-form-item label="机构" required prop="institutionCode">
                <el-select v-model="editForm.institutionCode" placeholder="请选择机构" style="width: 100%">
                  <el-option
                      v-for="item in arr_ins"
                      :key="item.institutionCode"
                      :label="item.userName"
                      :value="item.institutionCode">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="item">
              <el-form-item label="房间类型名称" required prop="name">
                <el-input v-model="editForm.name" placeholder="请输入房间类型名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="item">
              <el-form-item label="几人间" required prop="num">
                <el-col :span="24">
                  <el-input-number v-model="editForm.num" :min='1' style="width: 100%"></el-input-number>
                </el-col>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="item">
              <el-form-item label="价格" required prop="price">元/月
                <el-input type="number" v-model="editForm.price" placeholder="请输入价格"></el-input>
              </el-form-item>
            </el-col>

<!--            <el-col :span="12" class="item">-->
<!--              <el-form-item label="房间状态" required prop="status">-->
<!--                <el-select v-model="editForm.status" placeholder="选择房间状态" style="width:100%">-->
<!--                  <el-option-->
<!--                      v-for="item in status2"-->
<!--                      :key="item.value"-->
<!--                      :label="item.label"-->
<!--                      :value="item.value">-->
<!--                  </el-option>-->
<!--                </el-select>-->
<!--              </el-form-item>-->
<!--            </el-col>-->

          </el-row>
        </el-form>


      </div>
      <div class="modal-footer">
        <el-button :loading="loading" type="primary" @click="confirm('editForm')">修改</el-button>
      </div>
    </div>
  </div>
</template>

<script>

import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";

export default {
  name: 'Edit',
  props: ["arr_ins"],
  data() {
    return {
      loading: false,

      editForm:{
        timeStr:timeStr,
        sign:'',
        staffCode:getStaffCode(),
        institutionCode: '',
        name:'',
        num:'',
        status:'',
        roomTypeCode:'',
        price:''
      },

      status2: [{
        value: 0,
        label: '正常'
      }, {
        value: 1,
        label: '被禁用'
      }],

      rules:{
        number:[
          { required: true, message: '请输入楼名称', trigger: 'blur' },
        ],
        roomType:[
          { required: true, message: '请选择房间类型', trigger: 'blur' },
          { type: 'number', message: '房间类型必须为数字值'}
        ],
        price:[
          { required: true, message: '请输入金额', trigger: 'blur' },
          {
            pattern: /^([0-9]?)+(\.[0-9][0-9]?)?$/,
            message: "小数点后最多只能输入两位", trigger: 'blur'
          }
        ],
        institutionCode:[
          { required: true, message: '请选择机构', trigger: 'blur' },
        ],
      }


    }
  },

  methods: {

    init(row){

      this.editForm.name = row.name;
      this.editForm.num = row.num;
      this.editForm.roomTypeCode = row.roomTypeCode;
      this.editForm.status = row.status;
      this.editForm.price = row.priceMonth;
      this.editForm.institutionCode = row.institutionCode;

    },
    closeSelf() {
      this.$emit("closeEdit");
    },

    confirm(editForm){
      this.$refs[editForm].validate((valid) => {
        if(valid){
          this.addSubmit();
        }else {
          console.log('error submit!!');
          return false;
        }
      })
    },

    addSubmit(){

      if(this.loading){
        return;
      }else{
        this.loading = true;
      }

      this.editForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"RoomType/GovEditIns",
        data: this.editForm
      }).then(
          (response) => {
            this.loading = false;
            if (response.data.error == 0) {
              this.$emit("closeEdit");
              this.$emit("getList");
            }else if(response.data.error == 1){
              this.$message({type: 'info', message: response.data.message});
            }
          }
      )
    },

  }
}


</script>

<style lang="scss" scoped>

</style>
